import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

const post = (data) => {
    return instance.post(apis.User.Post, data)
}
// 获取头像
const getAvatar = (data) => {
    return instance.put(apis.User.GetAvatar, data)
}

const get = () => {
    return instance.get(apis.User.Get)
}
// 余额
const balance = () => {
    return instance.get(apis.employeePage.balance)
} 
// 店长余额
const ownerBalance = () => {
    return instance.get(apis.User.Balance)
}
// 用户库存
const userStock = () => {
    return instance.get(apis.User.UserStock)
}
// 店长员工库存
const employeeStock = () => {
    return instance.get(apis.User.EmployeeCode)
}
// 担保申请人数
const getGuaranteenum = (phone) => {
    return instance.post(apis.User.GuaranteeNumber + '?phoneNumber=' + phone)
}
// 修改消息状态
const chat = (id) => {
    return instance.post(apis.User.Chat + '?id=' + id)
}
// 消息列表
const chatlist = (page,pageSize,MesType) => {
    return instance.get(apis.User.Chatlist + '?Page=' + page + '&Limit=' + pageSize + '&MesType=' + MesType)
}
// 消息详情
const chatDetail = (id) => {
    return instance.get(apis.User.ChatDetail + '?id=' + id)
}
// 获取消息状态是否已读
const getChatStatus = () => {
    return instance.get(apis.User.ChatStatus)
}
// 获取不同消息类型未读的个数
const getMesNum = () => {
    return instance.get(apis.User.ChatGetMesNum )
}
// 获取商品码数量
const goodsCodeNum = () => {
    return instance.get(apis.User.GoodsCodeNum)
}
// 员工能否购买新的库存
const employeenBuy = () => {
    return instance.get(apis.User.EmployeeIsCanBuy)
}
// 获取员工店长商品码库存数量 用户优惠码
const employeeCode = () => {
    return instance.get(apis.User.EmployeeCode)
}

//是否可以取消申请店员
const isCanRevocation = () => {
    return instance.post(apis.User.IsCanRevocation)
}
//撤销申请店员
const revocationApply = () => {
    return instance.post(apis.User.RevocationApply)
}
// 判断店长是否是法人
const getpartner = () => {
    return instance.get(apis.partnerList.Get)
} 
// lhy 新增
//获取用户积分 
const getUserScore = () => {
    return instance.get(apis.User.UserScore)
}
// 获取雇佣数量
const getInvitationQuantity = () => {
    return instance.get(apis.User.InvitationQuantity)
}
// 获取积分跳转链接
const getIntegralLogin = () => {
    return instance.post(apis.User.integralLogin)
}
// 是否展示申请店员按钮
const isCanRegister = () => {
    return instance.post(apis.User.IsCanRegister)
}

// 剩余码数
const GetPCodeByPage = () => {
    return instance.get(apis.User.GetPCodeByPage)
}

// 发码
const ManualClaim = () => {
    return instance.post(apis.User.ManualClaim)
}
// 获取我的申请数量（申请店长）
const unReadMessageCount = ()=>{
    return instance.get(apis.User.unReadMessageCount)
}
// 获取我的申请数量（申请店长）
const applyCount = ()=>{
    return instance.get(apis.User.applyCount)
}
// 获取用户库存码
const getCode = () => {
    return instance.get(apis.Follow.getCode)
}
// 能否申请合伙达人
const canApplyPartner = () => {
    return instance.get(apis.User.canApplyPartner)
}

// 申请成为店长
const applyUpgradePartner = (data) => {
    return instance.post(apis.User.applyUpgradePartner,data)
}
// 能否申请销售
const CanBeSale = () => {
    return instance.post(apis.User.CanBeSale)
}
// 填写云电编号申请成为销售

const CheckUserCanBeSale = (data) => {
    return instance.post(apis.User.CheckUserCanBeSale,data)
}
// 获取销售审批待确认数量
const GetSalesApprovalQuantity = () => {
    return instance.get(apis.User.GetSalesApprovalQuantity)
}
// 获取销售店长申请待确认数量
const GetPartnerApprovalQuantity = () => {
    return instance.get(apis.User.GetSalesUpgradePartnerApprovalQuantity)
}
// 查询用户码信息
const CheckUserIsPickUp = () => {
    return instance.get(apis.User.CheckUserIsPickUp)
}
// 查询用户提货码列表
const SelectUserPickUp = () => {
    return instance.get(apis.User.SelectUserPickUp)
}
export default {
    post,
    getAvatar,
    get,
    balance,
    ownerBalance,
    userStock,
    employeeStock,
    getGuaranteenum,
    chat,
    chatlist,
    chatDetail,
    getChatStatus,
    getMesNum,
    goodsCodeNum,
    employeenBuy,
    employeeCode,
    isCanRevocation,
    revocationApply,
    getpartner,
    getUserScore,
    getIntegralLogin,
    isCanRegister,
    GetPCodeByPage,
    ManualClaim,
    unReadMessageCount,
    applyCount,
	getCode,
    getInvitationQuantity,
    canApplyPartner,
    applyUpgradePartner,
    CanBeSale,
    CheckUserCanBeSale,
    GetSalesApprovalQuantity,
    GetPartnerApprovalQuantity,
    CheckUserIsPickUp,
    SelectUserPickUp
}